import { mdiHandCoinOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { DrawerBody, DrawerFooter, DrawerHeader } from '@/components/ui/drawer'
import { ProgressCircleRing, ProgressCircleRoot, ProgressCircleValueText } from '@/components/ui/progress-circle'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IQuotasDrawerProps } from '@/types/gigiChat/Quotas'

import AdvancedQuota from './components/accordion'

const QuotasDrawer = ({ isOpen, quotas, onClose, percentage, onMoreQuota }: IQuotasDrawerProps) => {
    const { t } = useTranslation()
    const [message, setMessage] = useState<string>('')
    const [isDisabled, setIsDisabled] = useState<boolean>(true)

    useEffect(() => {
        if (message && isDisabled) {
            setIsDisabled(false)
        } else if (!message && !isDisabled) {
            setIsDisabled(true)
        }
    }, [message, isDisabled])

    useEffect(() => {
        if (!isOpen) {
            setMessage('')
        }
    }, [isOpen])

    const onMessageSet = (userMessage: string) => {
        setMessage(userMessage)
    }

    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose} noPadding={true}>
            <DrawerHeader borderBottomWidth="1px" borderColor="gray.300" py="24px">
                <Box display="flex" alignItems="center">
                    <Icon
                        path={mdiHandCoinOutline}
                        size={1}
                        color={useColorModeValue('var(--chakra-colors-gray-800)', 'var(--chakra-colors-gray-500)')}
                    />
                    <Text ml="18px">{t('global.quotas.drawer.title')}</Text>
                </Box>
            </DrawerHeader>
            <DrawerBody px="0" pt="24px">
                <Box display="flex" alignItems="center" px="24px">
                    <ProgressCircleRoot value={percentage} size="xl" color="dark.700" transform="rotateY(180deg)">
                        <ProgressCircleValueText asChild>
                            <Box transform="rotateY(180deg)" top="33%" left="0">
                                {percentage}%
                            </Box>
                        </ProgressCircleValueText>
                        <ProgressCircleRing />
                    </ProgressCircleRoot>
                    <Text marginLeft="30px" fontFamily="GSKPrecision-Bold" fontSize="21px" letterSpacing="0.25px">
                        Remaining credits
                    </Text>
                </Box>
                <AdvancedQuota
                    total={quotas.individual.creditsQuota.toFixed(2)}
                    remaining={quotas.individual.creditsRemaining.toFixed(2)}
                    onMessageSet={onMessageSet}
                />
            </DrawerBody>
            <DrawerFooter borderTopWidth="1px" borderColor="gray.300" justifyContent="flex-start" px="24px" py="32px">
                <Button variant="secondary" mr="18px" onClick={onClose}>
                    {t('global.quotas.drawer.buttons.close')}
                </Button>
                <Button
                    variant="secondary"
                    mr="18px"
                    onClick={() => {
                        onMoreQuota(message)
                        setMessage('')
                        setIsDisabled(true)
                    }}
                    disabled={isDisabled}
                >
                    {t('global.quotas.drawer.buttons.requestQuota')}
                </Button>
            </DrawerFooter>
        </DrawerDialog>
    )
}

export default QuotasDrawer
